import { getLangByNation, getLocaleByNation, getTimeZoneByNation } from '@/utils/commonUtils';

const state = () => ({
  lang: getLangByNation(),
  locale: getLocaleByNation(),
  timeZone: getTimeZoneByNation()
  // 'Asia/Seoul',
  // "ko",      // 지역 설정: ko
});

const getters = {
  getLang: state => state.lang,
  getLocale: state => state.locale,
  getTimeZone: state => state.timeZone,
};

const actions = {
  // 로그인 정보저장
  setLang({ commit }, langData) {
    commit('SET_LANG', langData);
  },
  setLocale({ commit }, localeData) {
    commit('SET_LOCALE', localeData);
  },
  setTimeZone({ commit }, timeZoneData) {
    commit('SET_TIME_ZONE', timeZoneData);
  },
};

const mutations = {
  SET_LANG(state, payload) {
    state.lang = payload;
  },
  SET_LOCALE(state, payload) {
    state.locale = payload;
  },
  SET_TIME_ZONE(state, payload) {
    state.timeZone = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
